export default () => ({
    isLoading: false,
    abortController: null,
    activeFilters: {},
    filters: {},

    init() {
        this.syncData(this.$refs.results)

        const onChange = (event) => {
            event?.preventDefault()
            this.updateResults()
        }

        this.$refs.form.addEventListener('change', onChange)
        this.$refs.form.addEventListener('submit', onChange)
    },

    syncData(el) {
        this.activeFilters = JSON.parse(el.dataset.activeFilters)
        this.filters = JSON.parse(el.dataset.filters)
    },

    replaceRef(name, page = 1) {
        const url = new URL(window.location.pathname, window.location.origin)
        const formData = new FormData(this.$refs.form)

        Array.from(formData.entries()).forEach(([key, value]) => {
            if (value) {
                url.searchParams.append(`${key}[]`, value)
            }
        })

        this.abortController?.abort()

        this.abortController = new AbortController()

        return fetch(url, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const results = doc.querySelector(`[x-ref="${name}"]`)

                if (results) {
                    this.$refs[name].innerHTML = results.innerHTML

                    this.syncData(results)
                }

                window.history.replaceState({}, '', url)
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error)
                }
            })
            .finally(() => {
                this.abortController = null
            })
    },

    updateResults(page) {
        this.isLoading = true

        this.replaceRef('results', page).finally(() => {
            this.isLoading = false
        })
    },

    hasActiveFilters(keys = []) {
        return keys.some((key) => {
            const value = this.activeFilters[key]

            return Array.isArray(value) ? value.length > 0 : Boolean(value)
        })
    },

    labelsForActiveFilters(keys = []) {
        const labels = []

        keys.forEach((key) => {
            const values = this.activeFilters[key]

            if (values) {
                Object.entries(values)?.forEach(([key, label]) => {
                    labels.push(label)
                })
            }
        })

        return labels.filter(Boolean)
    },

    clearFilters(keys = []) {
        keys.forEach((key) => delete this.activeFilters[key])

        this.$nextTick(() => this.updateResults())
    },
})
